/* eslint-disable-next-line */
import { ref, computed } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'
import * as userManagementService from '@/services/userManagementService'
//import { useUserManagement } from '@/composables/useUserManagement'


export function useEmailInvitation() {
  //const { loadUsers } = useUserManagement()
  const toast = useToast()
  const { t } = useI18n()
  
  // Reactive data
  const showInviteModal = ref(false)
  const isLoading = ref(false)
  const bulkLoading = ref(false)
  
  // Form data
  const formData = ref({
    email: '',
    service: null,
    message: ''
  })
  
  // Bulk invitation data
  const bulkEmails = ref([])
  const csvData = ref(null)
  const bulkService = ref(null)
  
  // Services data
  const services = ref([])
  
  // openInviteModal
  const openInviteModal = () => {
    showInviteModal.value = true
  }

  // Load services
  const loadServices = async () => {
    try {
      const response = await userManagementService.fetchServices()
      if (response?.data) {
        services.value = response.data
      }
    } catch (error) {
      console.error('Error loading services:', error)
    }
  }
  
  // Check if email exists in mail list
  const checkMailList = (email) => {
    const mailList = JSON.parse(localStorage.getItem('mailList') || '[]')
    return mailList.some(mail => mail.toLowerCase() === email.toLowerCase())
  }
  
  // Single invitation
  const sendSingleInvitation = async () => {
    try {
      if (!formData.value.email || !formData.value.service) {
        toast.add({
          severity: 'error',
          summary: t('common.error'),
          detail: t('common.please_fill_required_fields'),
          life: 4000
        })
        return false
      }
      
      // Check if email already exists
      if (checkMailList(formData.value.email)) {
        toast.add({
          severity: 'error',
          summary: t('common.error'),
          detail: t('common.email_already_exists', { email: formData.value.email }),
          life: 4000
        })
        return false
      }
      
      isLoading.value = true
      
      // Check if service exists, create if not
      let serviceId = formData.value.service
      /*
      if (typeof formData.value.service === 'string') {
        const existingService = services.value.find(s => s.name.toLowerCase() === formData.value.service.toLowerCase())
        if (!existingService) {
          const newService = await userManagementService.createService({
            name: formData.value.service
          })
          if (newService) {
            serviceId = newService.id
            services.value.push(newService)
          } else {
            toast.add({
              severity: 'error',
              summary: t('error'),
              detail: t('failed_to_create_service')
            })
            return false
          }
        } else {
          serviceId = existingService.id
        }
      }
      */
      
      const invitationData = {
        emails: [formData.value.email],
        service: serviceId,
        message: formData.value.message || ''
      }
      
      const response = await userManagementService.sendSingleInvitation(invitationData)
      
      if (response) {
        /*toast.add({
          severity: 'success',
          summary: t('success'),
          detail: t('user_manage.invitation_sent_successfully')
        })*/
        
        // Update mail list
        const mailList = JSON.parse(localStorage.getItem('mailList') || '[]')
        mailList.push(formData.value.email)
        localStorage.setItem('mailList', JSON.stringify(mailList))
        
        resetForm()
        return true
      } else {
        toast.add({
          severity: 'error',
          summary: t('common.error'),
          detail: t('user_manage.failed_to_send_invitation'),
          life: 4000
        })
        return false
      }
    } catch (error) {
      console.error('Error sending invitation:', error)
      toast.add({
        severity: 'error',
        summary: t('common.error'),
        detail: error.response?.data?.message || t('user_manage.failed_to_send_invitation'),
        life: 4000
      })
      return false
    } finally {
      isLoading.value = false
    }
  }
  
  // Bulk invitation
  const sendBulkInvitations = async () => {
    try {
      if (!bulkEmails.value.length || !bulkService.value) {
        toast.add({
          severity: 'warn',
          summary: t('warning'),
          detail: t('user_manage.please_fill_required_fields')
        })
        return false
      }
      
      bulkLoading.value = true
      
      // Filter out existing emails - no need
      /*const mailList = JSON.parse(localStorage.getItem('mailList') || '[]')
      const newEmails = bulkEmails.value.filter(email => 
        !mailList.some(mail => mail.toLowerCase() === email.toLowerCase())
      )
      
      if (newEmails.length === 0) {
        toast.add({
          severity: 'warn',
          summary: t('warning'),
          detail: t('user_manage.all_emails_already_exist')
        })
        return false
      }
      */
      
      // filter services with same name
      const uniqueServices = [...new Set(bulkService.value.map(service => service.toLowerCase()))]

      // Check if service exists, create if not
      let serviceIds = []
      //let serviceId = bulkService.value
      if (uniqueServices.length > 0) {
        //await loadServices()
        console.log(services.value, uniqueServices)
        let isSuccess = false
        const invitationPromises = uniqueServices.map(async (service, index) => {
          const existingService = services.value.find(s => s.name.toLowerCase().split("_")[0] === service.toLowerCase())
          let idService

          if (!existingService) {
            const newService = await userManagementService.createService({
              name: service.charAt(0).toUpperCase() + service.slice(1)
            })
            console.log(newService)
            if (newService) {
              serviceIds.push(newService.id)
              services.value.push(newService)
              idService = newService.id
            } else {
              toast.add({
                severity: 'error',
                summary: t('common.error'),
                detail: t('user_manage.failed_to_create_service'),
                life: 2000
              })
              return false
            }
          } else {
            console.log(existingService)
            serviceIds.push(existingService.id)
            idService = existingService.id
          }
          let bulkToSend = bulkEmails.value.filter(email => email[1].toLowerCase() === service.toLowerCase()).map(email => email[0]) 
          const invitationData = {
            emails: bulkToSend,
            service: idService,
            message: formData.value.message || ''
          }

          const response = await userManagementService.sendBulkInvitations(invitationData)

          if (response) {
            isSuccess = true
            toast.add({
              severity: 'success',
              summary: t('success'),
              detail: `${bulkToSend.length} ${t(bulkToSend.length === 1 ? 'user_manage.bulk_invitations_sent_successfully_single' : 'user_manage.bulk_invitations_sent_successfully', { service: service.charAt(0).toUpperCase() + service.slice(1) })}`,
              life: 3000
            })
            resetBulkForm()
            return true
          } else {
            toast.add({
              severity: 'error', 
              summary: t('error'),
              detail: `${t('user_manage.failed_to_send_invitations')} ${bulkEmails.value[index]}`,
              life: 3000
            })
            return false
          }
        })
        // Wait for all invitations to complete
        const results = await Promise.all(invitationPromises)
        return results.some(result => result === true) || isSuccess
      }
      return false
      
    } catch (error) {
      console.error('Error sending bulk invitations:', error)
      toast.add({
        severity: 'error',
        summary: t('error'),
        detail: error.response?.data?.message || t('user_manage.failed_to_send_invitations')
      })
      return false
    } finally {
      bulkLoading.value = false
    }
  }
  
  // Handle CSV upload
  const handleCSVUpload = (event) => {
    const file = event.files[0]
    if (!file) return
    
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const csv = e.target.result
        const lines = csv.split('\n')
        const emails = []
        
        // Skip header row and process data
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim()
          if (line) {
            const columns = line.split(',')
            const email = columns[0]?.trim()
            if (email && email.includes('@')) {
              emails.push(email)
            }
          }
        }
        
        bulkEmails.value = emails
        csvData.value = csv
        
        toast.add({
          severity: 'success',
          summary: t('success'),
          detail: `${emails.length} ${t('emails_loaded_from_csv')}`
        })
      } catch (error) {
        console.error('Error parsing CSV:', error)
        toast.add({
          severity: 'error',
          summary: t('error'),
          detail: t('failed_to_parse_csv')
        })
      }
    }
    reader.readAsText(file)
  }
  
  // Generate CSV template
  const generateCSVTemplate = () => {
    const csvContent = 'email,name\nexample@email.com,John Doe'
    const blob = new Blob([csvContent], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'invitation_template.csv'
    link.click()
    window.URL.revokeObjectURL(url)
  }
  
  // Reset forms
  const resetForm = () => {
    formData.value = {
      email: '',
      service: null,
      message: ''
    }
  }
  
  const resetBulkForm = () => {
    bulkEmails.value = []
    csvData.value = null
    bulkService.value = null
  }
  
  const resetInvitationForm = () => {
    resetForm()
    resetBulkForm()
    showInviteModal.value = false
  }
  
  // Handle invitation (updated to support both single and bulk)
  const handleInvitation = async (invitationData) => {
    try {
      const { type, data, serviceId, isBulk } = invitationData
      
      if (type !== 'send_invitation') {
        console.warn('Unknown invitation type:', type)
        return false
      }
      
      if (isBulk) {
        // Handle bulk invitation
        if (!data || !Array.isArray(data) || data.length === 0) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.please_provide_valid_data'),
            life:3000
          })
          return false
        }
        
        await loadServices()
        // Extract emails and services from bulk data
        const emails = data.map(item => [item.email, item.service || services.value.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0]?.name]).filter(email => email[0] && email[0].includes('@'))
        console.log(emails)
        if (emails.length === 0) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.no_valid_emails_found'),
            life: 3000
          })
          return false
        }
        
        // For bulk, we can use the service from the first item or a default service
        //const bulkServiceId = data[0]?.service || serviceId
        const bulkServices = data && data.length > 0 && services.value && services.value.length > 0 
          ? data.map(user => user?.service || services.value.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0]?.name)
          : []
        
        if (bulkServices.length <= 0) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.please_select_service')
          })
          return false
        }
        
        // Set bulk data and call bulk invitation method
        bulkEmails.value = emails
        bulkService.value = bulkServices
        
        return await sendBulkInvitations()
      } else {
        // Handle single invitation(s)
        if (!data || !Array.isArray(data) || data.length === 0) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.please_provide_valid_emails'),
            life: 3000
          })
          return false
        }
        
        if (!serviceId) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.please_select_service'),
            life: 3000

          })
          return false
        }
        
        // For single invitations, we can send multiple emails with the same service
        const validEmails = data.filter(email => email && email.includes('@'))
        
        if (validEmails.length === 0) {
          toast.add({
            severity: 'error',
            summary: t('common.error'),
            detail: t('user_manage.no_valid_emails_found'),
            life: 3000
          })
          return false
        }
        
        // Send invitations for each email
        let successCount = 0
        let failureCount = 0
        
        for (const email of validEmails) {
          // Set form data for each email
          formData.value.email = email
          formData.value.service = serviceId
          
          const result = await sendSingleInvitation()
          if (result) {
            successCount++
          } else {
            failureCount++
          }
        }
        
        // Show summary toast
        if (successCount > 0) {
          toast.add({
            severity: successCount === validEmails.length ? 'success' : 'warn',
            summary: t(successCount === validEmails.length ? 'common.success' : 'common.partial_success'),
            detail: `${successCount} ${t(successCount <= 1 ? 'user_manage.invitations_sent_successfully_single' : 'user_manage.invitations_sent_successfully')}${failureCount > 0 ? `, ${failureCount} ${t('common.failed')}` : ''}`,
            life: 3000

          })
          
        }
        
        return successCount > 0
      }
      
    } catch (error) {
      console.error('Error in handleInvitation:', error)
      toast.add({
        severity: 'error',
        summary: t('common.error'),
        detail: error.message || t('user_manage.failed_to_process_invitation'),
        life: 3000
      })
      return false
    }
  }
  
  return {
    // Reactive data
    showInviteModal,
    isLoading,
    bulkLoading,
    formData,
    bulkEmails,
    csvData,
    bulkService,
    services,
    
    // Methods
    loadServices,
    sendSingleInvitation,
    sendBulkInvitations,
    handleCSVUpload,
    generateCSVTemplate,
    resetForm,
    resetBulkForm,
    resetInvitationForm,
    handleInvitation,
    checkMailList,
    openInviteModal
  }
}